module.exports = __webpack_public_path__ + "img/menu.df0838c7.svg";